module.exports = __webpack_public_path__ + "img/9788959525195.b7cd5fcf.jpg";